<template>
    <div :class="$style['list']">
        <div v-if="!programs.length" :class="$style['list__no-result']">
            <NoResult :type="typeNoResult" @resetFilter="$emit('resetFilter')"/>
        </div>

        <div v-if="programs.length" :class="$style['list__items']">
            <div v-for="program in programs" :key="program.id" :class="$style['list__item']">
                <Program :program="program"
                         :personLink="personLink"
                         :sendData="sendData"
                         :filter="filter"
                         @changeAnother="$emit('changeAnother')"/>
            </div>
        </div>

    </div>
</template>

<script>
    import NoResult from '../NoResult/NoResult';
    import Program from '../Program/Program';

    export default {
        components: {
            NoResult,
            Program
        },

        props: ['filter', 'programs', 'typeNoResult', 'personLink', 'sendData']
    }
</script>

<style lang="scss" module>
    .list {
        position: relative;
    }

    .list__item {
        &:not(:last-child) {
            @include margin-level(bottom, cyan);
        }
    }

    .list__item_special_offer {
        @include margin-level(top, turquoise);
        @include margin-level(bottom, yellow);
    }
</style>
